import React, { useCallback, useRef, useState } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { MobileSpacer } from 'components/mobile-spacer';
import { useKeyboardState } from 'hooks/use-keyboard-state';

const DescriptionInput = styled.input`
  width: 100%;
  border: 1px solid ${Styles.color.grey.three};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  resize: none;
  color: ${Styles.color.secondary};
  font-family: ${Styles.fontFamily.base};
  padding: 12px;
  font-size: 1rem;
  margin-top: 0.5rem;

  &.error {
    border-color: ${Styles.color.error};
  }
`;

const Legend = styled.legend`
  display: block;
  font-size: 1.2rem;
  font-weight: ${Styles.fontWeight.heavy};
  margin: 0 0 1rem 0;
`;

const DescriptionContainer = styled.fieldset`
  border: 0;
  margin-bottom: 1rem;
`;

interface ITableNumber {
  onChange: (change: string) => void;
  value?: string;
}

export const TableNumber: React.FC<ITableNumber> = ({ onChange, value }) => {
  const { isKeyboardOpen, keyboardHeight } = useKeyboardState();
  const [hasError, setHasError] = useState(false);
  const { formatMessage } = useIntl();

  const inputRef = useRef<HTMLInputElement>(null);

  const onFocus = useCallback(() => {
    if (!inputRef.current?.value) {
      setHasError(true);
    }
  }, []);

  const onInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const cleanValue = (e.target.value || '').replace(/[^0-9]+/g, '');
      setHasError(!cleanValue);
      onChange(cleanValue);
    },
    [onChange]
  );

  return (
    <DescriptionContainer>
      <Legend>{formatMessage({ id: 'tableServiceDetailsHeader' })}</Legend>
      <label htmlFor="table-number-input">
        {formatMessage({ id: 'tableServiceDetailsDescription' })}
      </label>
      <DescriptionInput
        data-testid="table-service-table-number-input"
        id="table-number-input"
        className={hasError ? 'error' : ''}
        onChange={onInputChange}
        onFocus={onFocus}
        required
        name="tableNumber"
        value={value}
        ref={inputRef}
      />
      {isKeyboardOpen && <MobileSpacer height={keyboardHeight} />}
    </DescriptionContainer>
  );
};
